import { combineReducers } from 'redux';
import mainReducerData from './mainReducers';

export default combineReducers({
    mainReducerData
})